import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { ICustomTermsAndConditionsNotes, BaseResponse } from '../models';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomTermsConditionsNotesService {

  constructor(private httpClient: HttpClient) { }


  public getTermsAndConditions(): Observable<Array<ICustomTermsAndConditionsNotes>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.SUBMITTALPACKAGE.GET_TERMS_AND_CONDITIONS}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public saveTermsAndConditions(customTermsAndConditionsObj: ICustomTermsAndConditionsNotes): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.SUBMITTALPACKAGE.SAVE_TERMS_AND_CONDITIONS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, customTermsAndConditionsObj).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
}


